import { render, staticRenderFns } from "./VisitorsIndex.vue?vue&type=template&id=54f30c25&lang=pug&"
import script from "./VisitorsIndex.vue?vue&type=script&lang=js&"
export * from "./VisitorsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports